import { Project, ProjectRole, Theme } from "../project/typesDefinition";
import { PaginatedResponse, Entity, PaginatedResult } from "../typesDefinition";
import { UserResponse } from "../user/typesDefinition";

export interface Company extends Entity {
  name: string;
  vatNumber: string;
  client: Client;
  vatExempted: boolean;
}

export interface Client extends Entity {
  name?: string;
  accessRights?: PaginatedResult<UserResponse>;
  projects: Project[];
  companies: Company[];
}

export interface ClientPaginatedResponse extends PaginatedResponse<Client> {
  clients: PaginatedResult<Client>;
}

export interface ClientResponse {
  client: Omit<Client, "projects">;
}

export interface Timesheet {
  id?: string;
  theme: Theme;
  duration: number;
  role?: ProjectRole;
  notes?: string;
  activityId?: string;
}

export interface TimesheetFormValue {
  id?: string;
  date: string;
  duration: number;
  notes?: string | null;
  userId?: string | null;
  userName?: string | null;
  projectId?: string | null;
  themeId?: string | null;
  roleId?: string | null;
  activityId?: string | null;
}

export interface TimerPeriod extends Entity {
  startTime?: Date;
  stopTime?: Date;
  duration?: number;
}

export interface Timer extends Entity {
  date: Date;
  theme?: Theme;
  role?: ProjectRole;
  periods: TimerPeriod[];
  notes?: string;
  activityId?: string;
}

export enum Language {
  FR = "fr",
  EN = "en",
  ES = "es",
  NL = "nl",
  DE = "de",
}
